import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Divider, FormHelperText, FormLabel, Grid, Stack, Typography } from "@mui/material";
import moment from "moment";
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import Label from "../../../components/Common/Label";
import LoadingDialog from "../../../components/Common/LoadingDialog";
import Notification from '../../../components/Common/Notification';
import CustomButton from "../../../components/Form/CustomButton";
import CustomIconButton from "../../../components/Form/CustomIconButton";
import CustomTextField from "../../../components/Form/CustomTextField";
import RadioButtonGroup from "../../../components/Form/RadioButtonGroup";
import Helpers from "../../../helpers/helpers";
import { createSchools, getGeneral, getSchoolsDetails, resetAttachmentState, resetSchoolsState, updateSchools } from "../../../store/actions";
import ContractsFields from "./ContractsFields";



const AddSchool = ({ type, title, error, addSchools, editSchools, schoolsDetails, attachment }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { ID } = useParams();
    const [edit, setEdit] = useState(false)
    const [editId, setEditId] = useState(false)
    const [errorSet, setError] = useState({})
    const [openDiscountField, setOpenDiscountField] = useState(false)
    const [tempDiscount, setTempDiscount] = useState(false)
    const [tempDiscountEmpty, setTempDiscountEmpty] = useState(false)
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const defaultValues = {
        name: "",
        status: "",
        contracts: [],
    }
    const data = [
        { value: 1, label: "Active" },
        { value: 0, label: "Inactive" },
    ]
    const [loading, setIsLoading] = useState(false);
    const [values, setFormValues] = useState(defaultValues);
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        dispatch(resetAttachmentState());
        dispatch(resetSchoolsState());
        initData()

        const handleResize = () => {
            setWidth(window.innerWidth); // Update state when window resizes
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize); // Cleanup on unmount
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (addSchools?.code === "success") {
            setNotification({
                open: true,
                msg: "Added Successfully",
                type: "success",
            })
            dispatch(getGeneral());
            setIsLoading(false)
            initData()
            navigate("/settings-school")
        } else if (addSchools?.code === "invalid_field") {
            setNotification({
                open: true,
                msg: addSchools?.message,
                type: "error",
            })
            dispatch(getGeneral());
            setIsLoading(false);
        } else if (addSchools?.code === "exception") {
            setNotification({
                open: true,
                msg: addSchools?.message,
                type: "error",
            })
            dispatch(getGeneral());
            setIsLoading(false);
        }
    }, [addSchools])

    useEffect(() => {
        if (editSchools?.code === "success") {
            setNotification({
                open: true,
                msg: "Edited Successfully",
                type: "success",
            })
            initData()
            dispatch(getGeneral());
            setIsLoading(false);
        } else if (editSchools?.code === "invalid_field") {
            setNotification({
                open: true,
                msg: editSchools?.message,
                type: "error",
            })
            dispatch(getGeneral());
            setIsLoading(false);
        } else if (editSchools?.code === "exception") {
            setNotification({
                open: true,
                msg: addSchools?.message,
                type: "error",
            })
            dispatch(getGeneral());
            setIsLoading(false);
        }
    }, [editSchools])

    useEffect(() => {
        if (schoolsDetails) {
            setFormValues({
                name: schoolsDetails?.name || '',
                status: schoolsDetails?.status,
                contracts: schoolsDetails?.contracts || '',
            })
        }
    }, [schoolsDetails])

    const handleSubmit = (type) => {
        let data = []
        if (values?.contracts?.length > 0) {
            values?.contracts?.map((x, idx) =>
                x?.id ?
                    data?.push({ id: x?.id, code: x?.code, start_date: x?.start_date, end_date: x?.end_date }) :
                    data?.push({ code: x?.code, start_date: x?.start_date, end_date: x?.end_date })
            )
        }
        let payload = {
            name: values?.name,
            status: values?.status,
            contracts: data
        }
        if (type === "Add") {
            setIsLoading(true)
            dispatch(createSchools(payload));
        }
        else if (type === "Edit") {
            setIsLoading(true)
            dispatch(updateSchools({ id: ID, data: payload }));
        }

    }

    const initData = () => {
        if (type === "Edit" && ID) {
            dispatch(getSchoolsDetails({ id: ID }));
        }
    }

    const handleDeleteFiles = (id) => {
        const tempFile = values?.contracts
        const filteredFIle = tempFile && tempFile.length > 0 && tempFile.filter((x, idx) =>
            id !== idx
        )
        // setSelectedDiscountItem(filteredFIle);
        setFormValues((prevValues) => ({
            ...prevValues,
            contracts: filteredFIle
        }))
    }

    const handleEditFiles = (id) => {
        const tempFile = values?.contracts
        setEdit(true)
        setEditId(id)
        const filteredFIle = tempFile && tempFile?.length > 0 && tempFile.filter((x, idx) =>
            id === idx
        )
        setOpenDiscountField(false)
        setTempDiscount(filteredFIle?.[0])
    }

    const handleAddDiscount = () => {
        const start = new Date(tempDiscountEmpty?.start_date);
        const end = new Date(tempDiscountEmpty?.end_date);
        if (!tempDiscountEmpty?.code || !tempDiscountEmpty?.start_date || !tempDiscountEmpty?.end_date) {
            setNotification({
                open: true,
                msg: "Please fill in all required field.",
                type: "error"
            })
            setError({
                code: "The contract code field is required.",
                start_date: "The start date field is required.",
                end_date: "The end date field is required.",
            })
            return
        } else {
            setError("")
        }
        if ((tempDiscountEmpty?.end_date || tempDiscountEmpty?.start_date) && start > end) {
            setNotification({
                open: true,
                msg: "Start date must before the end date.",
                type: "error"
            })
            setError({
                start_date: "The end date field must later than start date.",
                end_date: "The start date must be earlier than the end date.",
            })
            return;
        } else {
            setError("")
            // Only push if valid
            setFormValues((prev) => ({
                ...prev,
                contracts: [
                    ...(prev.contracts || []),
                    {
                        code: tempDiscountEmpty?.code,
                        start_date: tempDiscountEmpty?.start_date,
                        end_date: tempDiscountEmpty?.end_date,
                    }
                ]
            }));

            setOpenDiscountField(false);
            setTempDiscountEmpty("");
        }



    };

    const handleSaveEdit = (idx) => {
        const start = new Date(tempDiscount.start_date);
        const end = new Date(tempDiscount.end_date);

        // Validation: required fields
        if (!tempDiscount?.code || !tempDiscount?.start_date || !tempDiscount?.end_date) {
            setNotification({
                open: true,
                msg: "Please fill in all required fields.",
                type: "error"
            });
            setError({
                code: !tempDiscount?.code ? "The contract code field is required." : "",
                start_date: !tempDiscount?.start_date ? "The start date field is required." : "",
                end_date: !tempDiscount?.end_date ? "The end date field is required." : "",
            });
            return; // stop here
        }

        // Validation: date order
        if (tempDiscount.start_date && tempDiscount.end_date && start > end) {
            setNotification({
                open: true,
                msg: "Start date must before the end date.",
                type: "error"
            });
            setError({
                start_date: "The end date field must later than start date.",
                end_date: "The start date must be earlier than the end date.",
            })
            return; // stop here
        }

        // If passed all checks
        setError({});
        setFormValues((prev) => {
            const updatedContracts = [...(prev.contracts || [])];
            updatedContracts[idx] = {
                id: updatedContracts[idx]?.id,
                code: tempDiscount?.code,
                start_date: tempDiscount?.start_date,
                end_date: tempDiscount?.end_date,
            };
            return {
                ...prev,
                contracts: updatedContracts
            };
        });

        setEditId("");
        setTempDiscount({});
        setOpenDiscountField(false);
    };

    return (
        <React.Fragment>
            {
                width <= 425 &&
                <div className="mobile-button-container">
                    <CustomButton
                        title={type === 'Add' ? 'Save' : 'Save Changes'}
                        press={() => handleSubmit(type)}
                        height={40}
                        backgroundColor={'#101010'}
                        textColor={'white'}
                        width={'100%'}
                    />
                </div>
            }
            <div className="page-content">
                <Container fluid>
                    <LoadingDialog open={loading || !schoolsDetails} />
                    <Notification notification={notification} setNotification={setNotification} />
                    <Breadcrumbs
                        backRoute={"/settings-school"}
                        breadcrumbItems={[
                            { title: 'Schools', link: "/settings-school" },
                            { title: title, link: "#" },
                        ]}
                    >
                        {
                            width > 425 &&
                            <CustomButton
                                title={type === 'Add' ? 'Save' : 'Save Changes'}
                                press={() => handleSubmit(type)}
                                height={40}
                                backgroundColor={'#101010'}
                                textColor={'white'}
                            />
                        }
                    </Breadcrumbs>
                    {/* <Card className="p-3">
                        <CardBody> */}
                    <Grid container spacing={2}>
                        <Grid item xs={12} lg={8} pb={3}>
                            <Card className="p-3 px-2">
                                <CardBody>
                                    <div className="setting-header">BASIC INFO</div>
                                    <Divider className="my-2 mb-4" />
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12}>
                                            <CustomTextField
                                                title={'School Name'}
                                                values={values?.name}
                                                onChange={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    name: e
                                                }))}
                                                placeholder="e.g. Victoria Junior College"
                                            />
                                            {(addSchools?.code === "invalid_field" || editSchools?.code === "invalid_field") && !values?.name && <FormHelperText sx={{ color: "red" }}>The school name field is required.</FormHelperText>}
                                        </Grid>
                                    </Grid>
                                </CardBody>
                            </Card>

                            <Card className="p-3 px-2">
                                <CardBody>
                                    <div className="setting-header">CONTRACTS</div>
                                    <Divider className="my-2 mb-2" />
                                    <Stack direction={{ sm: "row", xs: "column" }} pt={2} gap={1} justifyContent={"space-between"} pb={2}>
                                        <Stack direction={"row"} gap={1}>
                                            <div style={{ border: '1px solid #D0D0D0', borderRadius: "5px", height: "42px", width: "42px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <i className="ri-contract-line" style={{ fontSize: "24px" }}></i>
                                            </div>
                                            <div>
                                                <span className="setting-form-section-header" >Contracts</span>
                                                <Typography><span className="setting-form-subtitle">{values?.contracts?.length || 0} contract</span></Typography>
                                            </div>
                                        </Stack>
                                        <Stack display={"contents"} justifyContent={{ xs: "flex-start", sm: "flex-end" }}>
                                            <CustomButton
                                                borderStyle={"1px solid #282828"}
                                                title={"Add contract"}
                                                press={() => (setOpenDiscountField(true), setEditId(""), setEdit(false))}
                                                height={40}
                                                backgroundColor={'white'}
                                                textColor={'#282828'}
                                            />
                                        </Stack>
                                    </Stack>
                                    <Grid container mt={1} pb={1} gap={1}>
                                        {values?.contracts && values?.contracts.length > 0 && values?.contracts.map((f, i) => {
                                            return (
                                                <>
                                                    {
                                                        <Grid item xs={12} sm={5.9}
                                                            className="mb-0"
                                                            key={i + "-file"}
                                                            style={{ border: "1px solid #d0d0d0", padding: "10px", borderRadius: "8px", paddingTop: "15px", paddingBottom: "15px" }}
                                                        >
                                                            <Stack flexDirection={{ xs: "column", sm: "row" }} justifyContent={"space-between"}>
                                                                <div className="p-2">
                                                                    <Stack direction={"row"} spacing={1} gap={1}>
                                                                        <span className="" style={{ fontFamily: 'Manrope', fontSize: 14, fontWeight: 600, color: "#282828" }}>
                                                                            {f?.code}
                                                                        </span>
                                                                        {f?.status && <Label.SchStatusLabel label={f?.status} backgroundColor={"#FFF5F4"} marginLeft={"0px"} />}
                                                                    </Stack>
                                                                    <Typography><span className="setting-form-subtitle">Duration: {moment(f.start_date).format("DD MMM YYYY")} - {moment(f.end_date).format("DD MMM YYYY")} </span></Typography>
                                                                    {error &&
                                                                        <FormHelperText sx={{ color: "red" }}>
                                                                            {error && Helpers?.getCustomErrorMessageByPrefix(error, "contracts.")}
                                                                        </FormHelperText>}
                                                                </div>
                                                                <div className="d-flex flex-row justify-content-end">
                                                                    <div className="justify-content-end">
                                                                        <CustomIconButton
                                                                            iconName={'ri-pencil-line'}
                                                                            onClick={(e) => handleEditFiles(i)} />
                                                                    </div>
                                                                    <div className="justify-content-end">
                                                                        <CustomIconButton
                                                                            iconName={'ri-delete-bin-line'}
                                                                            onClick={(e) => handleDeleteFiles(i)}
                                                                            backgroundColor={'#ED1A3D'}
                                                                            color={'white'}
                                                                            borderStyle={"1px solid #ED1A3D"}
                                                                        />
                                                                    </div>

                                                                </div>

                                                            </Stack>
                                                        </Grid>
                                                    }
                                                    {
                                                        edit && editId === i &&
                                                        <ContractsFields type={"Edit"} contracts={schoolsDetails?.contracts} setNotification={setNotification} setOpenDiscountField={setOpenDiscountField} tempDiscount={tempDiscount} setTempDiscount={setTempDiscount}
                                                            handleAddDiscount={handleAddDiscount} edit={edit} setEditId={setEditId} handleSaveEdit={handleSaveEdit} id={i} setEdit={setEdit} errorSet={errorSet} setError={setError} />
                                                    }
                                                </>


                                            );
                                        })}
                                    </Grid>

                                    {
                                        openDiscountField &&
                                        <ContractsFields type={"Add"} setOpenDiscountField={setOpenDiscountField} tempDiscount={tempDiscountEmpty}
                                            setTempDiscount={setTempDiscountEmpty} handleAddDiscount={handleAddDiscount} edit={false} setEditId={setEditId} errorSet={errorSet} setError={setError} />
                                    }
                                </CardBody>
                            </Card>
                        </Grid>
                        <Grid container item sm={12} lg={type === 'add' ? 12 : 4}>
                            <Grid item xs={12} sm={12}>
                                <Card className="p-3 px-2">
                                    <CardBody>
                                        <div className="setting-header">SETTINGS</div>
                                        <Divider className="my-2 mb-4" />
                                        <div className="mt-3">
                                            <RadioButtonGroup
                                                title={'Status'}
                                                value={values?.status}
                                                data={data}
                                                setValue={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    status: e,
                                                }))}
                                                required="true"
                                                name="status"
                                                error={error && error?.status}
                                            />
                                        </div>
                                        {type === "Edit" &&
                                            <>
                                                <FormLabel style={{ fontFamily: 'Manrope-Bold', fontSize: 14 }}>Last modified</FormLabel>
                                                <div>{moment(schoolsDetails?.updated_at).format("DD MMM YYYY")}, {moment(schoolsDetails?.updated_at).format("hh:mm A")}</div>
                                            </>}
                                    </CardBody>
                                </Card>

                            </Grid>
                        </Grid>
                    </Grid>
                    {/* </CardBody>
                    </Card> */}
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Schools, General }) {
    return {
        error: Schools.error,
        addSchools: Schools.addSchools,
        editSchools: Schools.updateSchools,
        schoolsDetails: Schools.schoolsDetails,
        attachment: General.attachment
    };
}

export default connect(mapStateToProps)(AddSchool);
